import script from "./SearchForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchForm.vue?vue&type=script&setup=true&lang=js"

import "./SearchForm.vue?vue&type=style&index=0&id=3b701140&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b701140"]])

export default __exports__